import React from 'react';
// Import the new submark logo
import submarkWhite from '../assets/submark-white.png';

const Preloader = () => {
  return (
    <div className="preloader-container">
      <div className="preloader-content">
        
        {/* Submark Logo (Stable, no pulse animation) */}
        <div className="preloader-logo-wrapper">
          <img src={submarkWhite} alt="Nightmark Security" className="preloader-shield" />
        </div>
        
        {/* Progress Bar */}
        <div className="preloader-progress-wrap">
          <div className="preloader-progress-bar"></div>
        </div>

      </div>
    </div>
  );
};

export default Preloader;